import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealSeniorDebtField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='senior-debt-helper-text'
          label='Senior Debt'
          id='senior_debt'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
          sx={{ input: { textAlign: 'right' } }}
        />

        {error ? (
          <FormHelperText id='senior-debt-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='senior-debt-helper-text'>
            Enter the total amount of all senior debt used to purchase the
            asset.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
